import { track } from './analytics';

/**
 * The public marketing site.
 *
 * Always the apex: `www.basiqr.com` 301-redirects to it in prod
 * (`infra/lib/stacks/serverless-stack.ts`), so linking `www` costs every
 * visitor a redirect hop.
 */
export const LANDING_SITE_URL = 'https://basiqr.com';

/**
 * Build a landing-site URL tagged with the surface that sent the visitor.
 *
 * These links must be real external anchors, never react-router `<Link>`:
 * an in-SPA `/` sends an anonymous visitor to RootRedirect → /login →
 * MobileGatePage, so a phone visitor who scanned a QR code is told BasiQR is
 * desktop-only (#260).
 */
export function landingSiteUrl(source: string, medium = 'powered_by'): string {
  const url = new URL(LANDING_SITE_URL);
  url.searchParams.set('utm_source', source);
  url.searchParams.set('utm_medium', medium);
  return url.toString();
}

/** Props every landing-site link needs to open safely in a new tab. */
export const EXTERNAL_LINK_PROPS = {
  target: '_blank',
  rel: 'noopener noreferrer',
} as const;

/** Fire-and-forget analytics for a landing-site click. */
export function trackLandingSiteClick(source: string) {
  track('powered_by_clicked', { source });
}
